import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-767de09a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "partner"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp"
}, "生态伙伴", -1));
const _hoisted_3 = {
  class: "partner-container fadeInUp",
  id: "scrollleft"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "partner-container fadeInUp",
  id: "scrollright"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "partner-container fadeInUp",
  id: "scrollleft1"
};
const _hoisted_8 = ["src"];
import { ref } from 'vue';
import seamScroll from '@/components/seamScroll';
import { isMobile } from '@/utils';
export default {
  __name: 'index',
  setup(__props) {
    const len = 24;
    const arr = [];
    for (let i = 0; i < len; i += 1) {
      arr.push({
        img: require(`./img/${i}.jpg`)
      });
    }
    const dataList = arr;
    const list1 = ref([]);
    const list2 = ref([]);
    const list3 = ref([]);
    if (isMobile()) {
      list1.value = dataList.splice(0, 8);
      list2.value = dataList.splice(0, 8);
      list3.value = dataList;
    } else {
      list1.value = dataList.splice(0, 12);
      list2.value = dataList;
    }
    const randomSort = arr => {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
      return arr;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_unref(seamScroll), {
        id: `scrollleft`,
        "class-option": {
          direction: 2,
          step: 0.2
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list1.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "partner-item",
            key: index
          }, [_createElementVNode("img", {
            class: "partner-img",
            src: item.img
          }, null, 8, _hoisted_4)]);
        }), 128))])]),
        _: 1
      }, 8, ["class-option"]), _createVNode(_unref(seamScroll), {
        id: `scrollright`,
        "class-option": {
          direction: 3,
          step: 0.2
        },
        style: _normalizeStyle(!_unref(isMobile)() ? `margin-top: 30px` : ``)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list2.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "partner-item",
            key: index
          }, [_createElementVNode("img", {
            class: "partner-img",
            src: item.img
          }, null, 8, _hoisted_6)]);
        }), 128))])]),
        _: 1
      }, 8, ["class-option", "style"]), _unref(isMobile)() ? (_openBlock(), _createBlock(_unref(seamScroll), {
        key: 0,
        id: `scrollleft1`,
        "class-option": {
          direction: 2,
          step: 0.3
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list3.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "partner-item",
            key: index
          }, [_createElementVNode("img", {
            class: "partner-img",
            src: item.img
          }, null, 8, _hoisted_8)]);
        }), 128))])]),
        _: 1
      }, 8, ["class-option"])) : _createCommentVNode("", true)]);
    };
  }
};